import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  Text,
} from '@knockrentals/knock-shared-web';

import './AiTemplateTypeAccordion.scss';

const useStyles = makeStyles({
  companyAccordion: {
    maxWidth: '1110px',
    minWidth: '768px',
  },
  templateSummary: {
    '&.MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '46px',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      marginBottom: 0,
    },
  },
});

export const templateCountText = (count) =>
  `${count} ${count === 1 ? 'Template' : 'Templates'}`;

const AiTemplateTypeAccordion = ({ children, title, templateCount = 0 }) => {
  const classes = useStyles();
  return (
    <Accordion
      className={classes.companyAccordion}
      TransitionProps={{ unmountOnExit: true }}
    >
      <AccordionSummary className={classes.templateSummary}>
        <div className="ai-template-accordion-summary">
          <Text variant="subtitle1">{title}</Text>

          <Text color="secondary" variant="body2">
            {templateCountText(templateCount)}
          </Text>
        </div>
      </AccordionSummary>

      <AccordionDetails>
        <div className="accordion-div">{children}</div>
      </AccordionDetails>
    </Accordion>
  );
};

AiTemplateTypeAccordion.propTypes = {
  children: PropTypes.node,
  templateCount: PropTypes.number,
  title: PropTypes.string,
};

export default AiTemplateTypeAccordion;
